import { Injectable } from '@angular/core';
import { environment } from '../config/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getUsers(appName='AR') {
    // this.apiUrl =  environment.apiUrl;
    return this.http.post<any>(this.apiUrl + '/dashboard/getusers',{ data: appName })
      .pipe(
        map(users => {
            return users;
        })
      );
  }

  updatePassword(payload: any){
    return this.http.post<any>(this.apiUrl + '/users/updatePassword',{ data: payload })
    .pipe(
      map(users => {
          return users;
      })
    );
  }

  updateMobile(payload: any){
    return this.http.post<any>(this.apiUrl + '/users/updateMobile',{ data: payload })
    .pipe(
      map(users => {
          return users;
      })
    );
  }

  verifyUser(payload: any){
    return this.http.post<any>(this.apiUrl + '/users/verifyUser',{ data: payload })
    .pipe(
      map(users => {
          return users;
      })
    );
  }
}